import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { NotificationsHeaderComponent } from './components/notifications-header/notifications-header.component';
import { TmNoteCardComponent } from './components/tm-note-card/tm-note-card.component';
import { NotificationsPageRoutingModule } from './notifications-routing.module';
import { NotificationsPage } from './pages/notifications.page';
import { TmNoteDetailsPage } from './pages/tm-notes-details/tm-note-details.page';
import { NoteHeaderComponent } from './components/note-header/note-header.component';
import { TmNoteProductCardComponent } from './components/tm-note-product-card/tm-note-product-card.component';
import { NotificationFiltersDesktopTabletComponent } from './components/notification-filters/notification-filters-desktop-tablet/notification-filters-desktop-tablet.component';
import { NotificationFiltersMobileComponent } from './components/notification-filters/notification-filters-mobile/notification-filters-mobile.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NotificationsPageRoutingModule,
    SharedModule,
    TranslateModule,
    ScrollingModule,
  ],
  declarations: [
    NotificationsPage,
    NotificationCardComponent,
    NotificationsHeaderComponent,
    TmNoteCardComponent,
    TmNoteDetailsPage,
    NoteHeaderComponent,
    TmNoteProductCardComponent,
    NotificationFiltersDesktopTabletComponent,
    NotificationFiltersMobileComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationsPageModule {}
